module.exports = __webpack_public_path__ + "img/GENERAL-IGNIS-2021-3.ade197c4.jpg";